module.exports = __webpack_public_path__ + "static/media/1008855.3824b646.png";